import React from 'react';
import { Stack, Title, Button, Group, Text } from '@mantine/core';
import ClientSelectionTable from './ClientSelectionTable';
import { useCampaign } from '../../context/CampaignContext';
import { useClient } from '../../context/ClientContext';

function ClientSelectionStep({ onBack, onNext }) {
  const { selectedClientIds } = useCampaign();

  const { loading } = useClient();

  return (
    <Stack gap="md">
      <Title order={3}>Select Clients</Title>
      <ClientSelectionTable loading={loading} />
      {selectedClientIds.length === 0 && <Text color="red" size="sm">Select at least one client.</Text>}
      <Group justify="space-between" mt="md">
        <Button variant="default" onClick={onBack}>&larr; Back</Button>
        <Button onClick={onNext} disabled={selectedClientIds.length === 0}>Next</Button>
      </Group>
    </Stack>
  );
}

export default ClientSelectionStep; 